import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AdminDataCreateDto } from '../dtos/admindata/adminDataCreateDto';
import { AdminDataUpdateDto } from '../dtos/admindata/adminDataUpdateDto';

@Injectable({
  providedIn: 'root'
})
export class VisaCountryService {
  private apiUrl = `${environment.apiUrl}/visaCountry`; // apiUrl'ı güncelliyoruz

  constructor(private http: HttpClient) {}

  getAll(): Observable<any> {
    return this.http.get<any>(this.apiUrl);
  }

  getById(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}`);
  }

  create(visaCountry: AdminDataCreateDto): Observable<any> {
    return this.http.post(this.apiUrl, visaCountry); // AdminDataDto kullanıyoruz
  }

  update(visaCountry: AdminDataUpdateDto): Observable<any> {
    return this.http.put(`${this.apiUrl}/${visaCountry.id}`, visaCountry);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }
}
